module.exports = __webpack_public_path__ + "img/magic-tips-icon.6e4f4204.svg";